
const selector = 'button, [href], input, select, textarea, [contenteditable]:not([contenteditable="false"]), iframe, [tabindex]:not([tabindex="-1"])'

export function focusTrap(...containers) {
	
	let previousFocus

	function enter() {	
		previousFocus = document.activeElement
		for (const el of containers) {
			el.addEventListener('keydown', onKeydown)
		}
		const first = visibleFocusables(containers)[0]
		if (first) first.focus()
	}

	function exit() {
		previousFocus.focus()
		for (const el of containers) {
			el.removeEventListener('keydown', onKeydown)
		}
	}

	function onKeydown(e) {	
		if (e.key !== "Tab" || document.activeElement !== e.target) return
		const visible = visibleFocusables(containers)
		const index = visible.indexOf(document.activeElement)
		if (index === -1) return
        const last = visible.length - 1
		if (index === 0 && e.shiftKey) {
            e.preventDefault()
			visible[last].focus()
		} else if (index === last && !e.shiftKey) {
            e.preventDefault()
			visible[0].focus()
		}
	}

	return { 
		enter,
		exit
	}
}

function visibleFocusables(containers) {
	const visible = []
	for (const el of containers) {
		if (el.matches(selector) && isFocusable(el)) visible.push(el)
		for (const node of el.querySelectorAll(selector)) {
			if (isFocusable(node)) visible.push(node)
		}
	}
	return visible
}

function isFocusable(el) {
	return !el.disabled && el.tabIndex !== -1 && el.checkVisibility({ checkVisibilityCSS: true })
}
